// extracted by mini-css-extract-plugin
export default {"sortedDefault":"Arrow_sortedDefault__visKu"};